import { DialogContent, DialogContentProps, styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../../../utils/fontSizeUtility";
import { breakpointValues, customBreakpoints } from "../../../../styles/breakpoints";

export const PlatformDialogContent = styled(
  DialogContent,
  {}
)<DialogContentProps>(({ theme }) => ({
  paddingTop: pxToRem(8),
  paddingBottom: pxToRem(8),
  paddingRight: pxToRem(8),
  paddingLeft: pxToRem(8),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  [customBreakpoints.up(breakpointValues.md)]: {
    paddingRight: pxToRem(24),
    paddingLeft: pxToRem(24),
  },
})) as React.ComponentType<DialogContentProps>;
